<template>
  <bk-page 
		class="shareInvitefriendPage" 
		:class="[scroll ? 'view-scroll': '']"
		pageType="navPage" 
		:navBarInfo="navBarInfo" 
		@scroll="handleScroll"
	>
    <bk-view class="view-header-main">
      <!-- <bk-view class="view-invitationRules" @click="setShowPage('invitationRules')">
        <bk-lang code="userInfo_shareInvitefriend_invitationrules"  />
				<bk-icon icon="icon-youjiantou"></bk-icon>
      </bk-view> -->
    </bk-view>
    <bk-view class="view-container">
      <bk-view class="view-invitedInfo-main">
				<!-- <shareChannel :memberInfo="memberInfo" /> -->

        <bk-view class="view-myInvitation-main">
          <bk-view class="view-myinvitation-button">
            <bk-lang code="userInfo_shareInvitefriend_myInvitation"></bk-lang>
          </bk-view>
          <bk-view class="view-progress-main">
            <!-- <bk-view  class="view-progress-item">
              <bk-lang code="userInfo_shareInvitefriend_invited"></bk-lang>
              <bk-view class="view-value">1</bk-view>
            </bk-view> -->
            <bk-view  class="view-progress-item">
              <bk-lang code="userInfo_shareInvitefriend_completed"></bk-lang>
              <bk-view class="view-value">{{ total || 0 }}</bk-view>
            </bk-view>
          </bk-view>
        </bk-view>
      </bk-view>

      <rewardEarned @action="handleRewardEarnedAction" />
    </bk-view>

    <transition name="rightFadeIn">
      <Component :is="showPage" @close="setShowPage()" />
    </transition>

  </bk-page>
</template>

<script>
	import invitationRules from './subPages/invitationRules/invitationRules.vue';
	import rewardEarned from './subViews/rewardEarned/rewardEarned.vue';
	import shareChannel from './subViews/shareChannel/shareChannel.vue';
	import { customerReq } from '@/reqService';

	export default {
		name:'shareInvitefriend',
		components:{ invitationRules, rewardEarned, shareChannel },
		data (){
			return {
				loadView:'',
				navBarInfo: {
					langCode_title:'userInfo_item_referralRewards',
					backFlag: true,
				},
				showPage:'',
				userInfo:this.$bk_getUserInfo(),
				curShop:this.$bk_getShopDetailInfo(),
				memberInfo:{},
				total:0,
				scroll:false,
			};
		},
		mounted (){
			this.initData();
		},
		methods:{
			initData (){
				this.requestGetChainMemberInfo();
			},
			async requestGetChainMemberInfo (){
				let params = {
					custId:this.curShop.custId,
					userId:this.userInfo.id
				};
				const res = await customerReq.requestGetChainMemberInfo(this, params);

				if(res?.id){
					customerReq.requestPostShareReadMark(this, { memberId: res.id});
					this.memberInfo = res;
				}
				
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			handleRewardEarnedAction ({ total }){
				this.total = total;
			},
			handleScroll (e){
				this.scroll = e.target?.scrollTop >=90;
			}
		}
	};
</script>

<style lang="less">
@import './shareInvitefriend.less';
</style>